import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import InputField from '../../../components/form/InputField';
import TextAreaField from '../../../components/form/TextAreaField';
import { useTranslation } from 'react-i18next';

export type FormValues = {
  productNameEn: string;
  productNameAr: string;
  shortDescriptionEn: string;
  shortDescriptionAr: string;
  longDescriptionEn: string;
  longDescriptionAr: string;
  price: number;
};

interface Props {
  register: UseFormRegister<FormValues>;
  errors: FieldErrors<FormValues>;
  defaultValues?: Partial<FormValues>; // <-- هنا الجديد
}

const ProductForm: React.FC<Props> = ({ register, errors, defaultValues }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">

      {/* Product Name */}
      <div className="flex md:flex-row flex-col gap-4">
        <div className="flex-1">
          <InputField
            placeholder={t("product_name_en")}
            defaultValue={defaultValues?.productNameEn}
            register={register("productNameEn", { required: t("required_field") })}
            error={errors.productNameEn}
          />
        </div>
        <div className="flex-1">
          <InputField
            placeholder={t("product_name_ar")}
            defaultValue={defaultValues?.productNameAr}
            register={register("productNameAr", { required: t("required_field") })}
            error={errors.productNameAr}
          />
        </div>
      </div>

      {/* Short Description */}
      <div className="flex md:flex-row flex-col gap-4">
        <div className="flex-1">
          <InputField
            placeholder={t("short_description_en")}
            defaultValue={defaultValues?.shortDescriptionEn}
            register={register("shortDescriptionEn", { required: t("required_field") })}
            error={errors.shortDescriptionEn}
          />
        </div>
        <div className="flex-1">
          <InputField
            placeholder={t("short_description_ar")}
            defaultValue={defaultValues?.shortDescriptionAr}
            register={register("shortDescriptionAr", { required: t("required_field") })}
            error={errors.shortDescriptionAr}
          />
        </div>
      </div>

      {/* Long Description */}
      <TextAreaField
        placeholder={t("long_description_en")}
        defaultValue={defaultValues?.longDescriptionEn}
        register={register("longDescriptionEn", { required: t("required_field") })}
        error={errors.longDescriptionEn}
      />
      <TextAreaField
        placeholder={t("long_description_ar")}
        defaultValue={defaultValues?.longDescriptionAr}
        register={register("longDescriptionAr", { required: t("required_field") })}
        error={errors.longDescriptionAr}
      />

      {/* Price */}
      <InputField
        placeholder={t("price")}
        type="number"
        step="0.01"
        defaultValue={defaultValues?.price}
        register={register("price", { required: t("required_field"), valueAsNumber: true })}
        error={errors.price}
      />
    </div>
  );
};

export default ProductForm;
